/*
  La fiche livre — trois comportements, aucune dépendance.

  1. LE PRÉNOM. Un seul champ, et deux choses changent : la couverture le
     porte, et la question intérieure se réécrit autour de lui. C'est la
     démonstration la plus courte de ce que fait le moteur, posée exactement
     là où la décision se prend.

  2. LE FORMAT COMMANDE L'ÉCHELLE. Les gammes ne coûtent pas le même prix
     selon le format, et l'une d'elles n'existe pas en poche. Choisir le
     format met donc à jour les prix et explique, le cas échéant, pourquoi
     une gamme n'est pas disponible — jamais une offre grisée sans raison.

  3. LE CHOIX SUIT LE VISITEUR. Format, gamme et prénom sont ajoutés au lien
     du parcours : on ne redemande pas ce qui vient d'être donné.

  Principe de repli, comme partout dans ce thème : sans JavaScript, la fiche
  reste complète et achetable. Les prix affichés par défaut sont ceux du
  grand format, le prénom d'exemple est déjà écrit, et le lien du parcours
  fonctionne sans paramètre. Ce fichier n'ajoute jamais de contenu.
*/

(() => {
  const racine = document.querySelector('[data-mlo-produit]');
  if (!racine) return;

  const saisie = racine.querySelector('[data-mlo-produit-saisie]');
  const surCouverture = racine.querySelector('[data-mlo-produit-prenom-couverture]');
  const question = racine.querySelector('[data-mlo-produit-question]');
  const lien = racine.querySelector('[data-mlo-produit-lien]');
  const gammes = [...racine.querySelectorAll('[data-mlo-produit-gamme]')];
  const formats = [...racine.querySelectorAll('[data-mlo-produit-format]')];

  const exemple = racine.dataset.mloPrenomExemple || '';
  const modele = question ? question.dataset.modele || '' : '';

  let formatChoisi = 'grand';
  let gammeChoisie = '';

  /* ---------------------------------------------------------------- */
  /* 1. Le prénom                                                      */
  /* ---------------------------------------------------------------- */

  /*
    On n'insère jamais la frappe du visiteur comme du HTML : elle est posée
    en texte, et le soulignement est un élément qu'on construit à côté. Un
    prénom contenant un chevron ne doit pas pouvoir écrire dans la page.
  */
  function ecrireQuestion(prenom) {
    if (!question || !modele) return;
    question.textContent = '';

    const morceaux = modele.split('[prenom]');
    morceaux.forEach((morceau, i) => {
      question.appendChild(document.createTextNode(morceau));
      if (i < morceaux.length - 1) {
        const marque = document.createElement('span');
        marque.className = 'mlo-produit__substitue';
        marque.textContent = prenom;
        question.appendChild(marque);
      }
    });
  }

  function majPrenom() {
    const brut = (saisie ? saisie.value : '').trim();
    const prenom = brut || exemple;
    if (surCouverture) surCouverture.textContent = prenom;
    ecrireQuestion(prenom);
    majLien();
  }

  /* ---------------------------------------------------------------- */
  /* 2. Le format commande l'échelle                                   */
  /* ---------------------------------------------------------------- */

  function majFormat(valeur) {
    formatChoisi = valeur;

    formats.forEach((bouton) => {
      const actif = bouton.dataset.mloProduitFormat === valeur;
      bouton.setAttribute('aria-checked', actif ? 'true' : 'false');
    });

    gammes.forEach((gamme) => {
      const enPoche = gamme.dataset.mloEnPoche === 'true';
      const prix = gamme.querySelector('[data-mlo-produit-prix]');
      const raison = gamme.querySelector('[data-mlo-produit-hors-poche]');
      const indisponible = valeur === 'poche' && !enPoche;

      gamme.classList.toggle('mlo-produit__gamme--indisponible', indisponible);

      if (prix) {
        if (indisponible) {
          prix.textContent = '';
        } else {
          prix.textContent =
            valeur === 'poche'
              ? gamme.dataset.mloPrixPoche || ''
              : gamme.dataset.mloPrixGrand || '';
        }
      }
      if (raison) raison.hidden = !indisponible;

      // Une gamme devenue indisponible ne peut pas rester sélectionnée.
      if (indisponible && gamme.classList.contains('mlo-produit__gamme--choisie')) {
        gamme.classList.remove('mlo-produit__gamme--choisie');
        gammeChoisie = '';
      }
    });

    majLien();
  }

  /* ---------------------------------------------------------------- */
  /* 3. Le choix suit le visiteur                                      */
  /* ---------------------------------------------------------------- */

  /*
    LE CHOIX VOYAGE DANS DES CHAMPS CACHÉS, PLUS DANS L'URL.

    Le bouton était un lien : on lui réécrivait sa requête à chaque clic sur
    un format. C'est devenu un FORMULAIRE — parce que le parcours crée un
    projet de livre, et qu'un GET se fait pré-charger par les navigateurs et
    parcourir par les robots. On met donc le choix dans deux champs cachés.

    Le prénom, lui, n'accompagne plus le départ : il se saisit dès le premier
    écran du configurateur, et le transporter dans une URL le donnait à lire
    à tout ce qui journalise les requêtes.
  */
  const champFormat = racine.querySelector('[data-mlo-produit-champ-format]');
  const champGamme = racine.querySelector('[data-mlo-produit-champ-gamme]');

  function majLien() {
    if (champFormat) champFormat.value = formatChoisi;
    if (champGamme) champGamme.value = gammeChoisie || '';
  }

  /* ---------------------------------------------------------------- */
  /* Branchements                                                      */
  /* ---------------------------------------------------------------- */

  if (saisie) saisie.addEventListener('input', majPrenom);

  formats.forEach((bouton) => {
    bouton.addEventListener('click', () => majFormat(bouton.dataset.mloProduitFormat));
  });

  gammes.forEach((gamme) => {
    gamme.addEventListener('click', () => {
      if (gamme.classList.contains('mlo-produit__gamme--indisponible')) return;
      gammes.forEach((g) => g.classList.remove('mlo-produit__gamme--choisie'));
      gamme.classList.add('mlo-produit__gamme--choisie');
      const nom = gamme.querySelector('.mlo-produit__gamme-nom');
      gammeChoisie = nom ? nom.textContent.trim().toLowerCase() : '';
      majLien();
    });
  });

  // État de départ : le grand format, et la question déjà composée pour que
  // le soulignement de la substitution soit visible sans avoir rien tapé.
  ecrireQuestion(exemple);
  majFormat('grand');
})();
